import { Component, OnInit } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { AuthService, AuthTokenService, ObjetsService } from '../shared/services';

@Component({
  selector: 'app-dashboard',
  templateUrl: './full-layout.component.html',
  providers: [ ObjetsService, AuthService ]
})
export class FullLayoutComponent implements OnInit {

  public disabled = false;
  public status: {isopen: boolean} = {isopen: false};
  public logout_url;

  constructor(
    private readonly cookieService: CookieService,
    private readonly authTokenService: AuthTokenService
  ) {
  }

  public toggled(open: boolean): void {
  }

  public deconnexion() {
    const logout_url = this.cookieService.get('logout_url');

    // Invalidation de la session côté serveur (purge/expiration des cookies ACCESS_TOKEN /
    // REFRESH_TOKEN). Un échec de cet appel n'empêche pas la déconnexion locale.
    this.authTokenService.logout().subscribe(
      () => this.finalizeDeconnexion(logout_url),
      () => this.finalizeDeconnexion(logout_url)
    );
  }

  private finalizeDeconnexion(logoutUrl: string) {
    // Point d'entrée unique de déconnexion locale (cf. AuthTokenService.clearLocalSession) :
    // supprime tous les cookies applicatifs ET techniques (FranceConnect state/nonce/token...)
    // sur tous les paths connus, pour ne laisser aucune trace de la session précédente.
    this.authTokenService.clearLocalSession();
    document.location.href = logoutUrl;
  }

  public toggleDropdown($event: MouseEvent): void {
    $event.preventDefault();
    $event.stopPropagation();
    this.status.isopen = !this.status.isopen;
  }

  ngOnInit(): void {
  }

  getConnected(): boolean {
    return this.authTokenService.isConnected();
  }

  getGivenName(): string {
    return this.cookieService.get('given_name');
  }
}




// WEBPACK FOOTER //
// ./src/app/layouts/full-layout.component.ts